import { create } from 'zustand';

type OnboardingDialogState = {
  isOpen: boolean;
  // Bumped on each open so the conversation remounts and re-fetches.
  sessionKey: number;
  open: () => void;
  close: () => void;
};

export const useOnboardingDialogStore = create<OnboardingDialogState>((set) => ({
  isOpen: false,
  sessionKey: 0,
  open: () => set((state) => ({ isOpen: true, sessionKey: state.sessionKey + 1 })),
  close: () => set({ isOpen: false }),
}));
